import React, { useState } from "react";
import styles from "./ReceiptJournal.module.scss";
import { salesData } from "./data.js";

interface IProps {
  closeModel: any;
  // saveAndClose:any
}

const ReceiptJournal: React.FC<IProps> = ({ closeModel }) => {
  let currentDate = new Date();
  const [date, setDate] = useState("2022-06-17");

  // `${currentDate.getFullYear()}-${
  //   currentDate.getMonth() + 1
  // }-${currentDate.getDate()}`;
  const filterDate = () => {
    //console.log(date);
    window.alert(currentDate.getMonth());
    const ddmmyy = date;
    const [yy, mm, dd] = ddmmyy.split("-");
    const dateFilter = [dd, mm, yy].join("/");
    // window.alert(dateFilter);
    // setDate(dateFilter);
  };

  const calculateTotal = () => {
    let total = 0;
    const filteredSales = salesData.filter((item: any) => item.date === date);
    console.log(filteredSales.length);
    // return filteredSales.length;
    filteredSales.forEach(function (item: any) {
      total = total + item.sales;
    });
    return total;
  };
  return (
    <div className={styles.overlay_model}>
      <div className={styles.receipt_journal_model}>
        Receipt Journal
        <div className={styles.journal_header}>
          <label htmlFor="journal">Select date</label>
          <input
            type="date"
            onChange={(e: any) => {
              setDate(e.target.value);
            }}
          />
          <button onClick={filterDate}>Filter</button>
          <span>{" Showing for: " + date}</span>
        </div>
        <div className={styles.journal_body}>
          {/* {salesData.map((item: any, index: number) => (
            <div className={styles.invoice_item}>
              <span>{item.invoice_id}</span>
              <span>{item.date}</span>
              <span>{item.sales}</span>
            </div>
          ))} */}
          <div className={styles.invoice_item}>
            <table>
              <thead>
                <tr>
                  <th>Invoice No</th>
                  <th>Date</th>
                  <th>Sales</th>
                </tr>
              </thead>
              {salesData
                .filter((item: any) => item.date === date)
                .map((item: any, index: number) => (
                  <tbody>
                    <tr>
                      <td>{item.invoice_id}</td>
                      <td>{item.date}</td>
                      <tr>Rs. {item.sales.toFixed(2)}</tr>
                    </tr>
                    {/* <td>
                      <td>{item.date}</td>
                    </td>
                    <td>
                      <tr>Rs. {item.sales.toFixed(2)}</tr>
                    </td> */}
                  </tbody>
                ))}
            </table>
          </div>
        </div>
        <div className={styles.journal_footer}>
          <button onClick={closeModel}>CLOSE</button>
          {/* <div className={styles.total}>
            <span>Total sales: </span>
            <span>Rs. {calculateTotal().toFixed(2)}</span>
          </div> */}
          <span>Total sales:</span>

          <span>Rs. {calculateTotal().toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default ReceiptJournal;
